import { CampaignBrief } from "@widgets/CampaignBrief";
import ChangeAlert from "@widgets/CampaignBrief/ui/ChangeAlert";
import styles from "./styles.module.scss";

export function CampaignDetail() {
  return (
    <div className={styles.container}>
      <div>
        <>
          <ChangeAlert />
          <CampaignBrief />
        </>
      </div>
    </div>
  );
}
